import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchContentOrConfig } from '../APIServices/ContentOrConfigService';
import { activateLoading, deactivateLoading } from './GlobalSlice';
import { URL_ENDPOINTS } from '../../Utils/EndPoints';
import { processConfigData, processContentData } from '../../Utils/ContentOrConfigUtil';
import { timeFormatRefreshment } from '../APIServices/PreferencesService';

export interface IContentStackState {
  contentStackData: any;
  showBanner: boolean;
  configTableData: any;
}

const initialState: IContentStackState = {
  contentStackData: {},
  showBanner: false,
  configTableData: {},
};

export const contentStackSlice = createSlice({
  name: 'contentStack',
  initialState,
  reducers: {
    setShowBanner: (state, action: PayloadAction<boolean>) => {
      state.showBanner = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getContentStackData.fulfilled, (state, action) => {
      if (action?.payload) {
        if (action?.payload?.content) {
          const contentData = processContentData(action?.payload?.content);
          state.contentStackData = {
            ...state?.contentStackData,
            ...contentData,
          };
        }

        if (action.payload.config) {
          const configData = processConfigData(action.payload.config);
          configData?.FPO_APP_CONFIG?.PREFERENCES_INIT &&
            timeFormatRefreshment(configData?.FPO_APP_CONFIG?.PREFERENCES_INIT);
          state.configTableData = { ...state.configTableData, ...configData };
        }
      }
    });
  },
});

export const { setShowBanner } = contentStackSlice.actions;
export default contentStackSlice.reducer;
export const getContentStackData = createAsyncThunk(
  'ContentStack/getContentStackData',
  async (payLoad: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchContentOrConfig({
      url: URL_ENDPOINTS?.CONTENTORCONFIG?.COMMON,
      queryPayload: payLoad?.queryPayload,
      callback: payLoad?.callBack,
    });
    dispatch(deactivateLoading());
    return response;
  },
);
